const Creds = {
  username: "stillwater",
  password: "1234stillwater",
};

export default Creds;
